import { createUseStyles } from "react-jss"

export default createUseStyles({
  root: {
    marginTop: -16
  },
})
